document.addEventListener('DOMContentLoaded', function () {
  var scrollToTopBtn = document.querySelector('.scroll-to-top-cta');

  window.addEventListener('scroll', function () {
    // Calculate the scroll position
    var scrollHeight = window.scrollY;
    var windowHeight = window.innerHeight;

    // Show/hide the scroll-to-top button based on the scroll position
    if (scrollHeight > windowHeight * 0.25) {
      scrollToTopBtn.classList.remove('d-none');
    } else {
      scrollToTopBtn.classList.add('d-none');
    }
  });

  scrollToTopBtn.addEventListener('click', function () {
    // Scroll to the top of the page when the button is clicked
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});